import React from 'react';
import fields, { globalFieldLengths } from '@/constants/fields';
import { checkRequired, checkMaxLength } from '@/utils/errors';
import ActionDialogConfirmation from './ActionDialogConfirmation';
import FormValidationError from '../errors/FormValidationError';
import MarkdownEditor from '../text-editors/MarkdownEditor';

export const validateArchivalForm = (entity, reason, reasonIsMandatory) => {
  const errors = [];
  const title = 'archive.validation.reason.title';

  checkRequired(reason, [fields.DESCRIPTION], errors, entity, title, reasonIsMandatory);
  checkMaxLength(reason, [fields.DESCRIPTION], errors, entity, title, globalFieldLengths.description);

  return errors;
};

const ArchivalDialogConfirmation = ({
  children,
  confirmText,
  disabled,
  entities,
  entity,
  items,
  minimumDataEntryMet,
  reason,
  onChangeConfirmation,
  onChangeReason,
  submitForm,
  validationErrors,
}) => {
  const descriptionError = validationErrors.find((e) => (e.fields.includes(fields.DESCRIPTION)));

  return (
    <ActionDialogConfirmation
      action="archive"
      disabled={disabled}
      entities={entities}
      entity={entity}
      items={items}
      minimumDataEntryMet={minimumDataEntryMet}
      onChange={onChangeConfirmation}
      submitForm={submitForm}
      text={confirmText}
    >
      {children}
      <FormValidationError
        error={descriptionError}
        htmlFor="archive_reason"
        labelId={`${entity}.archive.reason`}
      >
        <MarkdownEditor
          autoFocus
          id="archive_reason"
          disabled={disabled}
          value={reason}
          onChange={(value) => onChangeReason(value)}
          maxEditorHeight={80}
          minPreviewHeight={94}
        />
      </FormValidationError>
    </ActionDialogConfirmation>
  );
};

export default ArchivalDialogConfirmation;
